import { PayloadAction } from '@reduxjs/toolkit';

import { getQuantityBreak } from '../../logic/quantity-break';
import { WritableAutoConfiguratorState } from '../slice';

type Payload = {
  priceUuid: string;
  isPending: boolean;
};

export function updateQuotePriceIsCreating(
  state: WritableAutoConfiguratorState,
  { payload: { priceUuid, isPending } }: PayloadAction<Payload>,
) {
  const quotePrice = getQuantityBreak(state, priceUuid);

  quotePrice.isPending = isPending;
}
